import {
    ADVANCED_DISBURSEMENTS_LIST_PAGE_SHIFT,
    CHANGE_ADVANCED_DISBURSEMENTS_LIST_SETTINGS,
    CLEAR_ADVANCE_DISBURSEMENTS_FILTERS,
    TOBAS_LIST_PAGE_SHIFT
} from "./index";

//action that changes the advanced disbursements list settings
export function changeAdvancedDisbursementsListSettings(payload) {
    return {
        type: CHANGE_ADVANCED_DISBURSEMENTS_LIST_SETTINGS,
        payload: payload
    }
}

//action that shifts the ad list page
export function advanceDisbursementsListPageShift(payload) {
    return {
        type: ADVANCED_DISBURSEMENTS_LIST_PAGE_SHIFT,
        payload: payload
    }
}

export function clearAdvanceDisbursementsFilters(payload) {
    return {
        type: CLEAR_ADVANCE_DISBURSEMENTS_FILTERS,
        payload: payload
    }
}